import * as THREE from 'three';
import { Scene } from 'three/webgpu';

export function loadNewPlanet(
  planetKey,
  planets,
  textureLoader,
  earthMaterial,
  atmosphereMaterial,
  atmosphere,
  earth,
  planetParameters,
  scene,
  ringMeshHolder
)
{
  const planet = planets[planetKey]

  // CLEANUP


  const oldRing = earth.getObjectByName("planetRing");
  if (oldRing) {
    oldRing.geometry.dispose();
    oldRing.material.dispose();
    earth.remove(oldRing);
  }

  if (earthMaterial.uniforms.uDayTexture.value) {
      earthMaterial.uniforms.uDayTexture.value.dispose();
  }
  if (earthMaterial.uniforms.uNightTexture.value) {
      earthMaterial.uniforms.uNightTexture.value.dispose();
  }
  if (earthMaterial.uniforms.uSpecularCloudsTexture.value) {
      earthMaterial.uniforms.uSpecularCloudsTexture.value.dispose();
  }

  // Load new texture
  const newDayTexture = textureLoader.load(planet.dayTexture)
  newDayTexture.colorSpace = THREE.SRGBColorSpace
  newDayTexture.anisotropy = 8

  const newNightTexture = textureLoader.load(planet.nightTexture || planet.dayTexture)
  newNightTexture.colorSpace = THREE.SRGBColorSpace
  newNightTexture.anisotropy = 8

  const newSpecularTexture = textureLoader.load(planet.specularTexture || planet.dayTexture)
  newSpecularTexture.anisotropy = 8

  ringMeshHolder.mesh = null;

  // Load Saturn Rings conditionally
  if (planet.saturnRingsTexture) {
    const saturnRingsTexture = textureLoader.load(planet.saturnRingsTexture);
    saturnRingsTexture.colorSpace = THREE.SRGBColorSpace;
    saturnRingsTexture.anisotropy = 8;

    const innerRadius = 1.3; // Distance from center to start of ring
    const outerRadius = 2.2; // Distance from center to end of ring
    const thetaSegments = 64; // Smoothness of the circle

    // RingGeometry
    const saturnRingsGeometry = new THREE.RingGeometry(innerRadius, outerRadius, thetaSegments);

    // --- UV MAPPING ---
    // We map the "Inner Edge" of the geometry to the "Left Side" of the image (U=0)
    // We map the "Outer Edge" of the geometry to the "Right Side" of the image (U=1)

    const pos = saturnRingsGeometry.attributes.position;
    console.log(pos);

    const uv = saturnRingsGeometry.attributes.uv;
    console.log(uv);

    const vertex = new THREE.Vector3();

    for (let i = 0; i < pos.count; i++) {
      vertex.fromBufferAttribute(pos, i);

      // Calculate exact distance of this vertex from the center
      const radius = vertex.length();

      // Normalize the radius range to 0.0 -> 1.0
      // (Current Radius - Inner Limit) / (Total Width of Ring)
      const u = (radius - innerRadius) / (outerRadius - innerRadius);

      // V is always 0.5 (center of texture height)
      uv.setXY(i, u, 0.5);
    }

    saturnRingsGeometry.attributes.uv.needsUpdate = true;

    const saturnRingsMaterial = new THREE.MeshBasicMaterial({
      map: saturnRingsTexture,
      transparent: true,
      side: THREE.DoubleSide,
    });

    const saturnRingsMesh = new THREE.Mesh(saturnRingsGeometry, saturnRingsMaterial);
    saturnRingsMesh.rotation.x = -Math.PI / 2;
    saturnRingsMesh.name = "planetRing";

    earth.add(saturnRingsMesh);

    ringMeshHolder.mesh = saturnRingsMesh;
  }

  // Update uniforms
  earthMaterial.uniforms.uDayTexture.value = newDayTexture
  earthMaterial.uniforms.uNightTexture.value = newNightTexture
  earthMaterial.uniforms.uSpecularCloudsTexture.value = newSpecularTexture

  // Update atmosphere colors
  planetParameters.atmosphereDayColor = planet.atmosphereDayColor
  planetParameters.atmosphereTwilightColor = planet.atmosphereTwilightColor

  earthMaterial.uniforms.uAtmosphereDayColor.value.set(planet.atmosphereDayColor)
  earthMaterial.uniforms.uAtmosphereTwilightColor.value.set(planet.atmosphereTwilightColor)
  atmosphereMaterial.uniforms.uAtmosphereDayColor.value.set(planet.atmosphereDayColor)
  atmosphereMaterial.uniforms.uAtmosphereTwilightColor.value.set(planet.atmosphereTwilightColor)

  // Show/hide atmosphere
  atmosphere.visible = planet.hasAtmosphere

  // Update Sizes
  earth.scale.setScalar(planet.scale)
  atmosphere.scale.setScalar(planet.scale * planet.atmosphereScale)


  // Update active thumbnail
  document.querySelectorAll('.planet-selector li').forEach(thumb => {
    thumb.classList.remove('active')
  })
  const activeThumbnail = document.querySelector(`[data-planet="${planetKey}"]`)
  if (activeThumbnail) {
    activeThumbnail.closest('li').classList.add('active')
  }
}
